import { FunctionComponent, useEffect, useState } from 'react';
import TextInputField from '../../Components/TextInput/TextInputField';
import { FormikProps, useFormik } from 'formik';
import Select from '../../Components/Select/Select';
import { ISlotList } from './ISlot';
import { AutocompleteOption } from '../../Components/Select/ISelectProps';
import * as Yup from 'yup';
import {
  addSlot,
  clearAddSlotState,
} from '../../Redux/Slicers/Slot/AddSlotSlicer';
import { useAppDispatch, useAppSelector } from '../../Redux/Store/Hooks';
import {
  clearUpdateSlotState,
  updateSlot,
} from '../../Redux/Slicers/Slot/UpdateSlotSlicer';
import { Autocomplete, SvgIcon } from '@mui/material';
import { useLocation } from 'react-router-dom';
import UploadButtonField from '../../Components/Button/UploadButtonField';
import { Upload } from '@mui/icons-material';

interface SlotFormProps {
  masterForm: (data: FormikProps<any>) => void;
}

const SlotForm: FunctionComponent<SlotFormProps> = (props) => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  const { updateableDate } = useAppSelector((state) => state.UpdateSlot);
  const { data: Slot } = useAppSelector((state) => state?.Slot);
  const { pathname } = location;
  const pathnameParts = location.pathname.split('/');
  const id = pathnameParts[pathnameParts.length - 1];
  const masterFrom = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      level_id: Yup.string().required('Please enter valid level'),
      // level_diagram: Yup.mixed()
      //   .required('Please select the image of the Level image')
      //   .test(
      //     'type',
      //     'Only the following formats are accepted: .jpeg, .jpg,svg and .png',
      //     (value: any) => {
      //       if (typeof value === 'string') return true; // Skip validation if value is not provided
      //       return (
      //         value &&
      //         (value.type === 'image/jpeg' ||
      //           value.type === 'image/png' ||
      //           value.type === 'image/svg+xml' ||
      //           value.type === 'image/jpg')
      //       );
      //     }
      //   ),
      // location_id: Yup.string().required('Please enter location_id'),
    }),
    onSubmit: (value) => {
      if (updateableDate && Object.keys(updateableDate).length !== 0) {
        dispatch(
          updateSlot({ location_id: id, ...value, id: updateableDate._id })
        );
      } else {
        dispatch(addSlot({ location_id: id, ...value }));
      }
    },
  });

  useEffect(() => {
    props.masterForm(masterFrom);
    if (updateableDate) {
      masterFrom.setFieldValue('level_id', updateableDate.level_id);
      masterFrom.setFieldValue('location_id', id);
      masterFrom.setFieldValue('level_diagram', updateableDate.level_diagram);
    }
    return () => {
      dispatch(clearAddSlotState());
      dispatch(clearUpdateSlotState());
      masterFrom.resetForm();
    };
  }, [updateableDate]);

  const data1 = Slot?.response?.data;
  if (!data1) {
    console.log('datanot found');
  }

  const projects = Array.isArray(data1)
    ? data1.map((project) => ({
        label: project.name,
        value: project._id!,
      }))
    : [];

  return (
    <form
      className="Slot_form"
      onSubmit={masterFrom.handleSubmit}
      onReset={masterFrom.handleReset}
      autoComplete="off">
      <TextInputField
        id="level_id"
        name="level_id"
        label="Level "
        value={masterFrom.values.level_id}
        onChange={masterFrom.handleChange}
        onBlur={masterFrom.handleBlur}
        helperText={masterFrom.touched.level_id && masterFrom.errors.level_id}
        error={
          masterFrom.touched.level_id && Boolean(masterFrom.errors.level_id)
        }
      />

      <UploadButtonField
        className="upload_field"
        name="level_diagram"
        onChange={(event) => {
          if (event.target.files?.length) {
            masterFrom.setFieldValue('level_diagram', event.target.files[0]);
          }
        }}
        onBlur={masterFrom.handleBlur}
        fileAccept="image/jpeg,image/png,image/svg+xml,image/jpg">
        {masterFrom.values.level_diagram ? (
          <img
            src={
              typeof masterFrom.values.level_diagram === 'string'
                ? `${process.env.REACT_APP_API_URL}/${masterFrom.values.level_diagram}`
                : URL.createObjectURL(
                    masterFrom.values.level_diagram as unknown as File
                  )
            }
            alt="level_diagram"
            height={168}
          />
        ) : (
          <>
            <SvgIcon
              component={Upload}
              inheritViewBox
            />
            Supported Format : (1000 x 1000 px) <br /> png, jpg, svg, jpeg
          </>
        )}
      </UploadButtonField>

      <button
        type="submit"
        style={{ display: 'none' }}
      />
    </form>
  );
};

export default SlotForm;

const initialValues = {
  // parking_type: "",
  // space_name: "",
  // zone_id: 0,
  // space_id: 0,
  // status: null
} as ISlotList;

